module.exports = __webpack_public_path__ + "static/media/desires.8333a81c.jpg";